// extracted by mini-css-extract-plugin
module.exports = {"undisabledButton":"OrangeButton_undisabledButton__1qUSw","disableButton":"OrangeButton_disableButton__1pZiX"};